// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2q_C3","inputWrap":"styles_inputWrap__XGA3W","input":"styles_input__24M_1"};